import { useState, useEffect } from 'react';

/**
 * Material Design 3 Window Size Classes:
 * - COMPACT: width < 600dp (es. smartphone verticali)
 * - MEDIUM: 600dp <= width < 840dp (es. tablet, pieghevoli)
 * - EXPANDED: width >= 840dp (es. desktop, monitor ampi)
 */
export const WINDOW_SIZE_CLASSES = {
    COMPACT: 'compact',
    MEDIUM: 'medium',
    EXPANDED: 'expanded'
};

export function getWindowSizeClass(width) {
    if (width < 600) return WINDOW_SIZE_CLASSES.COMPACT;
    if (width < 840) return WINDOW_SIZE_CLASSES.MEDIUM;
    return WINDOW_SIZE_CLASSES.EXPANDED;
}

export function useWindowSizeClass() {
    const [sizeClass, setSizeClass] = useState(() =>
        typeof window !== 'undefined' ? getWindowSizeClass(window.innerWidth) : WINDOW_SIZE_CLASSES.EXPANDED
    );

    const [dimensions, setDimensions] = useState(() => ({
        width: typeof window !== 'undefined' ? window.innerWidth : 1200,
        height: typeof window !== 'undefined' ? window.innerHeight : 800
    }));

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            const height = window.innerHeight;
            setDimensions({ width, height });
            setSizeClass(getWindowSizeClass(width));
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return {
        sizeClass,
        isCompact: sizeClass === WINDOW_SIZE_CLASSES.COMPACT,
        isMedium: sizeClass === WINDOW_SIZE_CLASSES.MEDIUM,
        isExpanded: sizeClass === WINDOW_SIZE_CLASSES.EXPANDED,
        width: dimensions.width,
        height: dimensions.height
    };
}
